import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "@/lib/supabaseClient";
import AddProjectWizard from "./AddProjectWizard";

export default function Projects() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showWizard, setShowWizard] = useState(false);

  useEffect(() => {
    load();
  }, []);

  async function load() {
    setLoading(true);
    const { data, error: fetchError } = await supabase
      .from("projects")
      .select("*, clients(company_name), project_types(name)")
      .order("created_at", { ascending: false });
    if (fetchError) setError(fetchError.message);
    setProjects(data || []);
    setLoading(false);
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-1">
        <h1 className="text-xl font-semibold text-foreground">Projects</h1>
      </div>
      <p className="text-sm text-muted-foreground mb-6">{projects.length} projects</p>

      {error && (
        <p className="text-sm text-destructive bg-destructive/10 rounded-md px-3 py-2 mb-4">{error}</p>
      )}

      <button
        onClick={() => setShowWizard(true)}
        className="bg-primary text-primary-foreground rounded-lg px-4 py-2 text-sm font-semibold mb-4"
      >
        + Add project
      </button>

      <div className="border border-border rounded-2xl bg-card overflow-hidden">
        {loading ? (
          <p className="text-sm text-muted-foreground p-5">Loading...</p>
        ) : projects.length === 0 ? (
          <p className="text-sm text-muted-foreground p-5">No projects yet, add your first one above.</p>
        ) : (
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-border">
                <th className="text-left font-mono text-[10.5px] uppercase tracking-wide text-muted-foreground px-5 py-3">
                  Project
                </th>
                <th className="text-left font-mono text-[10.5px] uppercase tracking-wide text-muted-foreground px-5 py-3">
                  Client
                </th>
                <th className="text-left font-mono text-[10.5px] uppercase tracking-wide text-muted-foreground px-5 py-3">
                  Objective
                </th>
              </tr>
            </thead>
            <tbody>
              {projects.map((p) => (
                <tr key={p.id} className="border-b border-border last:border-0 hover:bg-accent/60">
                  <td className="px-5 py-3.5 font-medium text-foreground">
                    <Link to={`/dashboard/agency/projects/${p.id}`} className="hover:underline">
                      {p.name}
                    </Link>
                  </td>
                  <td className="px-5 py-3.5 text-muted-foreground">{p.clients?.company_name}</td>
                  <td className="px-5 py-3.5">
                    <span className="font-mono text-[10.5px] bg-accent text-foreground rounded-full px-2.5 py-1">
                      {p.project_types?.name || "Custom"}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {showWizard && (
        <AddProjectWizard
          onClose={() => setShowWizard(false)}
          onSaved={() => {
            setShowWizard(false);
            load();
          }}
        />
      )}
    </div>
  );
}
